
<template>
    <div class="page_body">
        <div class="data_main">
            <div class="data_search" v-if="power.indexOf('1')>=0">
                <el-form ref="listQuery" :inline="true" :model="listQuery" size="small" label-width="72px">
                    <el-form-item label="水卡编号：" prop="cardNo">
                        <el-input v-model="listQuery.cardNo" placeholder="请输入水卡编号" @keyup.enter.native="toSearchList"></el-input>
                    </el-form-item>
  
                    <el-form-item label="商品分类：" prop="cardId">
                        <el-select v-model="listQuery.cardId">
                            <el-option label="全部水卡" value=""></el-option>
                            <el-option v-for="(item,index) in option" :key="index" :label="item.titleName" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
  
                    <el-form-item class="last">
                        <el-button type="primary" :loading="isSearchLoading" @click="toSearchList()">查 询</el-button>
                        <el-button @click="$refs['listQuery'].resetFields()">重 置</el-button>
                    </el-form-item>
                </el-form>
            </div>
    
            <div class="data_table mt18">
                <el-table :data="listData" style="width: 100%" v-loading="isRequestLoading">
                    <el-table-column prop="applyUserName" label="理赔用户" min-width="120px" align="center"></el-table-column>
                    <el-table-column prop="applyUserPhone" label="联系方式" min-width="120px" align="center"></el-table-column>
                    <el-table-column prop="cardNo" label="关联水卡码" min-width="120px" align="center"></el-table-column>
                    <el-table-column prop="reason" label="理赔理由" min-width="120px" align="center"></el-table-column>
                    <el-table-column prop="" label="配送时间" min-width="120px" align="center">
                      <template slot-scope="scope">
                        {{ scope.row.deliveryTime | times }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="createdAt" label="提交时间" min-width="120px" align="center">
                      <template slot-scope="scope">
                        {{ scope.row.createdAt | times }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="state" label="状态" min-width="140px" align="center">
                      <template slot-scope="scope">
                        <span v-if="scope.row.state == 0">未处理</span>
                        <span v-if="scope.row.state == 1">通过</span>
                        <span v-if="scope.row.state == 2">驳回</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="100">
                      <template slot-scope="scope">
                        <el-button type="text" @click="toDetail(scope.row.id)">查看</el-button>
                      </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-dialog class="popup_dialog" title="理赔详情" :visible.sync="claimDetail" :close-on-click-modal="false" :show-close="false" :destroy-on-close="true" width="600px">
              <div class="rightButton" @click="openPopup">理赔日志</div>
              <el-form ref="claimInfo" :model="claimInfo" label-width="120px" size="small">
                <el-form-item label="用户名：">
                    <div>{{claimInfo.applyUserName}}</div>
                </el-form-item>
                <el-form-item label="用户电话：">
                    <div>{{claimInfo.applyUserPhone}}</div>
                </el-form-item>
                <el-form-item label="关联水卡码：">
                    <div>{{claimInfo.cardNo}}</div>
                </el-form-item>
                <el-form-item label="理赔理由：">
                    <div>{{claimInfo.reason}}</div>
                </el-form-item>
                <el-form-item label="理赔凭证：" v-if="imgList.length>0">
                  <img class="imgList" v-for="(item,index) in imgList" :key="index" :src="imageURL + item" alt="" @click='showPic(imageURL + item)'>
                </el-form-item>
                <el-form-item label="配送时间：">
                    <div>{{claimInfo.deliveryTime | times}}</div>
                </el-form-item>
                <el-form-item label="提交时间：">
                    <div>{{claimInfo.createdAt | times}}</div>
                </el-form-item>
                <el-form-item label="审批状态：" v-if="claimForm.auditType == 14">
                  <el-select v-model="claimForm.auditType" :disabled="true">
                    <el-option label="理赔完成" :value="14"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="审批状态：" v-else>
                  <el-select v-model="claimForm.auditType" :disabled="claimInfo.state!=11">
                    <el-option label="未处理" :value="11"></el-option>
                    <el-option label="通过" :value="12"></el-option>
                    <el-option label="驳回" :value="13"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="审批意见：" v-if="claimInfo.state!=11">
                    <div>{{claimInfo.auditReason}}</div>
                </el-form-item>
                <el-form-item label="审批意见：" v-else>
                  <el-input type="textarea" :rows="4" v-model="claimForm.message" autocomplete="off" placeholder="请输入审批意见"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" :loading="isSubmitLoading" @click="postClaim" v-if="claimInfo.state==11">提  交</el-button>
                    <el-button @click="claimDetail=false">关  闭</el-button>
                </el-form-item>
            </el-form>
            </el-dialog>
            
            <el-dialog class="popup_dialog" title="理赔日志" :visible.sync="isOrderPopup" :close-on-click-modal="false" :show-close="false" :destroy-on-close="true" width="800px">
              <div class="data_table log_table mt18 pr0">
                <el-table :data="logListData" style="width: 100%" v-loading="isRequestLoading">
                  <el-table-column prop="claimId" label="理赔id"></el-table-column>
                  <el-table-column prop="info" label="信息"></el-table-column>
                  <el-table-column prop="createdAt" label="更新时间"></el-table-column>
                </el-table>
              </div>
              <el-button style="display: block;margin: 20px auto;" type="primary" size="medium" @click="closePopup">关闭</el-button>
            </el-dialog>
            <pagination :size="listQuery.pageSize" :total="pages.total" :current="listQuery.page" :pages="pages.pages" @pageChange="pageChange"/>
        </div>
        <imageViewer v-if="showViewer" :on-close="closeViewer" :url-list="showImageList" />
    </div>
  </template>
  
  <script>
    const imageViewer = () => import('@/components/imageViewer')
    import pagination from '@/components/pagination'
    import {mapState} from "vuex";
    import {getClaim,getCardList,getClaimDetail,postClaim} from '@/api'
    export default {
    name: "contentArticleIndex",
    data () {
      return {
        claimForm:{
          auditType:0,
          id:0,
          message:'',
        },
        imageURL: window.config.imageURL,
        claimDetail:false,
        claimInfo:{},
        isSubmitLoading:false,
        isOrderPopup: false,
        logListData: [],
        listQuery: {
          cardNo: '',
          cardId: '',
          selfFlag:false,
          page: 1,
          pageSize: 10
        },
        pages: {
          total: 0,
          pages: 0
        },
        option:[],
        isSearchLoading: false,
        isRequestLoading: false,
        listData: [],
        imgList:[],
        showImageList: [],
        showViewer:false,
        power:null
      }
    },
    computed: {
      ...mapState({
        listKeepAlive: state => state.app.listKeepAlive,
      })
    },
    filters:{
      times(e){
        if (e) return e.split(' ')[0]+' '+e.split(' ')[1]
      }
    },
    activated () {
      this.getClaim()
      this.getCardList()
    },
    created(){
      this.power = JSON.parse(localStorage.getItem('userRole')).power[4]
    },
    methods: {
      closeViewer () {
        document.body.style.overflow = this.prevOverflow;
        this.showViewer = false
      },
      showPic (pic) {
        this.showImageList = []
        this.showImageList.push(pic)
        this.prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.showViewer = true
      },
      closePopup(){
        this.isOrderPopup = false
        this.claimDetail = true
      },
      openPopup(){
        console.log(this.claimInfo)
        this.claimDetail = false
        this.logListData = this.claimInfo.claimLogList
        this.isOrderPopup = true
      },
      postClaim(){
        if (this.claimForm.auditType == 11) {
          return this.$message.error('请选择审批状态')
        }
        let newData = JSON.parse(JSON.stringify(this.claimForm))
        if (newData.auditType == 12) newData.auditType = 1
        if (newData.auditType == 13) newData.auditType = 2
        postClaim({data:newData}).then(res=>{
          if (res.code == 0) {
            this.$message.success('审批成功')
            this.claimDetail = false
            this.toSearchList()
          }
        })
      },
      getCardList(){
        getCardList({data:{type:-1}}).then(res=>{
          this.option = res.data
        })
      },
      pageChange (e) {
        this.listQuery.page = e.current
        this.listQuery.pageSize = e.size
        this.getClaim()
      },
      toSearchList () {
        this.listQuery.page = 1
        this.isSearchLoading = true
        this.getClaim()
      },
      toDetail (id) {
        getClaimDetail(id).then(res=>{
          this.claimInfo = res.data
          this.claimForm.id = id
          this.claimForm.message = ''
          this.claimForm.auditType = Number(res.data.state)
          this.logListData = res.data.logList
          let newList = []
					if (res.data.applyFile && res.data.applyFile.length>3) {
						JSON.parse(res.data.applyFile).forEach(i=>{
							newList.push(JSON.parse(i).data)
						})
					}
					this.imgList = newList
          this.claimDetail = true
        })
      },
      getClaim(){
        
        this.listQuery.selfFlag = false
        if (this.power.indexOf('3')>=0) {
          this.listQuery.selfFlag = true
        }
        getClaim(this.listQuery).then(res=>{
          this.isSearchLoading = false
          console.log(res)
          this.listData = res.data.records
          this.pages.total = res.data.total
          this.pages.pages = res.data.pages
        }).catch(()=>{
          this.isSearchLoading = false
        })
      },
    },
    components: {
      pagination,imageViewer
    }
  }
  </script>
  <style lang="scss" scoped>
  .popup_dialog{
    /deep/ .el-dialog{
      position: relative;
      .rightButton{
        font-size: 14px;
        color: #4288f2;
        cursor: pointer;
        position: absolute;
        right: 20px;
        top: 30px;
      }
    }
  }
  .pr0{
    padding-right: 0 !important;
  }
  .imgList{
    width: 100px;
    height: 100px;
    margin-right: 8px;
  }
  </style>